<div class="details-editor-wrapper">
    <div #ref></div>
</div>